import React from 'react'

const FooterTop = () => (
  <div className="footer__top">
    <div className="footer__container">
      <div className="footer__row">
        <a
          href="https://www.hepsiburada.com/teslimat"
          rel="nofollow"
          className="footer__top-item"
        >
          <img
            loading="lazy"
            src="https://images.hepsiburada.net/assets/footer/yarin-kapinda.svg"
            className="footer__top-item-icon"
          />
          <div className="footer__top-item-content">
            <h3 className="footer__top-item-title">Yarın Kapında</h3>
            <p className="footer__top-item-desc">
              Yarın Kapında ile ihtiyaçlarına ertesi gün sahip ol!
            </p>
          </div>
        </a>
        <a
          href="https://www.hepsiburada.com/tek-tikla-guvenli-alisveris"
          rel="nofollow"
          className="footer__top-item"
        >
          <img
            loading="lazy"
            src="https://images.hepsiburada.net/assets/footer/tek-tikla-alisveris.svg"
            className="footer__top-item-icon"
          />
          <div className="footer__top-item-content">
            <h3 className="footer__top-item-title">
              Tek Tıkla Güvenli Alışveriş
            </h3>
            <p className="footer__top-item-desc">
              Ödeme ve adres bilgilerinizi kaydedin, güvenli alışveriş yapın.
            </p>
          </div>
        </a>
        <a
          href="https://www.hepsiburada.com/mobil-uygulamalar"
          rel="nofollow"
          className="footer__top-item"
        >
          <img
            loading="lazy"
            src="https://images.hepsiburada.net/assets/footer/mobil-cebinizde.svg"
            className="footer__top-item-icon"
          />
          <div className="footer__top-item-content">
            <h3 className="footer__top-item-title">Mobil Cebinizde</h3>
            <p className="footer__top-item-desc">
              Dilediğiniz her yerden güvenli alışverişin keyfini çıkarın.
            </p>
          </div>
        </a>
        <a
          href="https://www.hepsiburada.com/kapinda-iade"
          rel="nofollow"
          className="footer__top-item"
        >
          <img
            loading="lazy"
            src="https://images.hepsiburada.net/assets/footer/kapinda-iade.svg"
            className="footer__top-item-icon"
          />
          <div className="footer__top-item-content">
            <h3 className="footer__top-item-title">Kapında İade</h3>
            <p className="footer__top-item-desc">
              Aldığınız ürünü iade etmek hiç bu kadar kolay olmamıştı.
            </p>
          </div>
        </a>
      </div>
    </div>
  </div>
)

export default FooterTop
